<template>
    <div>
        <div @click.prevent="open = true" class="btn-help">
            <svg class="svg-with-hover" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
                <path d="M20,2A18,18,0,1,1,2,20,18,18,0,0,1,20,2m0-2A20,20,0,1,0,40,20,20,20,0,0,0,20,0Z"/>
                <path d="M17.43,25.38a1.91,1.91,0,0,0,1.36.58h0a1.93,1.93,0,0,0,1.91-1.87V22.72l.42-.06A9.57,9.57,0,0,0,23.48,22a5,5,0,0,0,1.95-1.37,5.17,5.17,0,0,0,1.31-2.1l.22-.68a7.32,7.32,0,0,0,.22-2.09v0a7.41,7.41,0,0,0-1-3.74,8,8,0,0,0-6.75-3.65,11.43,11.43,0,0,0-3.39.58,8.48,8.48,0,0,0-2.64,1.76,1.67,1.67,0,0,0-.6,1.41,1.53,1.53,0,0,0,.71,1.48l.08.07a1.26,1.26,0,0,0,.92.34.73.73,0,0,0,.39-.06l.11-.05a2.44,2.44,0,0,0,1.07-.58,4.94,4.94,0,0,1,1.46-.92,4.22,4.22,0,0,1,5.2,1.47,3.21,3.21,0,0,1,.55,1.95,4.15,4.15,0,0,1-.61,2.37,4.09,4.09,0,0,1-1.64,1.37,7.33,7.33,0,0,1-2.32.39,1.64,1.64,0,0,0-1.28.54,1.85,1.85,0,0,0-.59,1.32V24.1a1.65,1.65,0,0,0,.5,1.23Z"/>
                <path d="M18.61,28.18h0a1.73,1.73,0,0,0-1.73,1.73,1.82,1.82,0,0,0,1.76,1.75,1.75,1.75,0,0,0,1.72-1.75A1.79,1.79,0,0,0,18.61,28.18Z"/>
            </svg>
        </div>
        <div class="modal fade" id="helpTextModal" tabindex="-1" role="dialog" aria-hidden="true" style="visibility: hidden">
            <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document" style="visibility: visible">
                <div class="modal-content min-keep-size resize">
                    <div class="modal-header header-draggable flex">
                        <h2>{{ trans('help-texts.modal.title') }}</h2>
                        <button @click.prevent="open = false" class="close-modal">
                            <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                                <path d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"/>
                            </svg>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="ck-content" v-html="content">
                        </div>
                    </div>
                    <div class="modal-footer">
                        <svg class="resize-icon" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" >
                            <path fill="gray" d="M14.228 16.227a1 1 0 0 1-.707-1.707l1-1a1 1 0 0 1 1.416 1.414l-1 1a1 1 0 0 1-.707.293zm-5.638 0a1 1 0 0 1-.707-1.707l6.638-6.638a1 1 0 0 1 1.416 1.414l-6.638 6.638a1 1 0 0 1-.707.293zm-5.84 0a1 1 0 0 1-.707-1.707L14.52 2.043a1 1 0 1 1 1.415 1.414L3.457 15.934a1 1 0 0 1-.707.293z"/>
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "HelpText",
    data() {
        return {
            open: false,
        }
    },
    props: {
        content: {
            type: String,
            default: '',
        }
    },
    watch: {
        open: function(value) {
            if (value) {
                this.show();
            } else {
                this.hide();
            }
        }
    },
    methods: {
        show: function () {
            const modal = $('#helpTextModal');
            modal.on('shown.bs.modal', function () {
                $(this).find('.modal-header').drags();
            });

            modal.modal({ show: true, backdrop: false, keyboard: false });
            $('body').removeClass('modal-open');
            $('.nav.nav-pills.nav-justified').css('display', 'none');
        },
        hide: function () {
            this.curentKeepTab = 1;
            $('#helpTextModal').modal('hide');
            this.$emit('modal-closed');
        },
    }
}
</script>

<style scoped>
.btn-help {
    color: #808080;
    cursor: pointer;
    margin-right: 12px;
    margin-top: 18px;
}

.btn-help svg {
    width: 1.75rem;
    height: 1.75rem;
}

@media screen and (max-width: 991px) {
    .btn-help {
        margin-right: 8px;
        margin-top: 12px;
    }

    .btn-help svg {
        width: 19px;
        height: 19px;
    }
}

.modal-dialog {
    margin-top: 96px;
}

.close-modal {
    padding: 0;
    margin: 0;
    border: none;
    outline: none;
    box-shadow: none;
    background-color: transparent;
    display: flex;
    opacity: 0.5;
    color: #000;
}

.close-modal:hover {
    opacity: .7;
}

.close-modal svg {
    width: 1rem;
    height: 1rem;
}

.modal-header {
    padding: 1rem 1.5rem;
}

.modal-header h2 {
    margin: 0;
    color: initial;
}

.modal-content {
    border-radius: 0.5rem;
    box-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
    border-color: #d5d6d7;
}

.modal-body {
    padding-left: 24px;
    padding-right: 24px;
}

.modal-footer {
    padding: 1rem 1.5rem;
    background-color: #f4f5f7;
}
</style>
